import React from "react";
import Dropdown from "./Dropdown";
import { FiMail } from "react-icons/fi";
import { FiTwitter } from "react-icons/fi";
import { FiFacebook } from "react-icons/fi";
import { FiInstagram } from "react-icons/fi";
import { FiYoutube } from "react-icons/fi";
import { Link } from "react-router-dom";
function Footer() {
  return (
    <footer className="">
      <div className="container footer-containe">
        <Dropdown title="offline store">
          <li className="py-2 font-bold font-primaryFont text-sm underline">
            <Link>
              Find Store Near Me
           </Link>
          </li>
        </Dropdown>
        <Dropdown title="GET TO KNOW US">
          <li className="py-2 font-primaryFont text-primary text-sm hover:text-secondary">
            <Link>
              Contact Us
           </Link>
          </li>
          <li className="py-2 font-primaryFont text-primary text-sm hover:text-secondary">
            <Link>
              FAQ'S
           </Link>
          </li>
          <li className="py-2 font-primaryFont text-primary text-sm hover:text-secondary">
            <Link>
              Blogs
           </Link>
          </li>
          <li className="py-2 font-primaryFont text-primary text-sm hover:text-secondary">
            <Link>
              Terms & Conditions
           </Link>
          </li>
        </Dropdown>
        <Dropdown title="TRACK OR RETURN/EXCHANGE ORDER">
          <li className="py-2 font-primaryFont text-primary text-sm hover:text-secondary">
            <Link>
              TRACK ORDER
           </Link>
          </li>
          <li className="py-2 font-primaryFont text-primary text-sm hover:text-secondary">
            <Link>
              PLACE RETURN/EXCHANGE REQUEST
           </Link>
          </li>
          <li className="py-2 font-primaryFont text-primary text-sm hover:text-secondary">
            <Link>
              RETURNS/EXCHANGE POLICY
           </Link>
          </li>
        </Dropdown>
        <Dropdown title="CUSTOMER CARE">
          <li className="py-2 font-primaryFont text-primary text-sm hover:text-secondary">
            <p className="">Timings: 10 AM - 7 PM (Mon - Sat)</p>
            <p className="">Whatsapp : +91 6366966283</p>
            <p className="">Instagram: @snitch.co.in</p>
          </li>
        </Dropdown>
        <Dropdown title="SIGN UP AND SAVE">
          <li className="py-2 font-primaryFont text-primary text-sm hover:text-secondary">
            <p className="">
              Sign up now and be the first to know about exclusive offers,
              latest fashion trends & style tips!
            </p>
          </li>
          <li className="flex justify-between items-center py-2 border-b-2 border-black w-[60%] font-primaryFont text-primary text-sm hover:text-secondary">
            <input
              type="text"
              className="focus:shadow-none px-2 border-none w-[80%] focus:outline-none rounded-none"
              placeholder="Enter Your Email "
            />
            <span className="w-[10%] text-xl">
              <FiMail />
            </span>
          </li>
          <li className="mt-2 py-2 font-primaryFont text-primary text-sm hover:text-secondary">
            <p className="flex justify-self-start items-center gap-2">
            <span className="border-[1px] hover:bg-black p-2 border-black rounded-full text-2xl text-black hover:text-white cursor-pointer">
                
                <FiTwitter />
              </span>
              <span className="border-[1px] hover:bg-black p-2 border-black rounded-full text-2xl text-black hover:text-white cursor-pointer">
                
                <FiFacebook />
              </span>
              <span className="border-[1px] hover:bg-black p-2 border-black rounded-full text-2xl text-black hover:text-white cursor-pointer">
                
                <FiInstagram />
              </span>
              <span className="border-[1px] hover:bg-black p-2 border-black rounded-full text-2xl text-black hover:text-white cursor-pointer">
                
                <FiYoutube />
              </span>
            </p>
          </li>
        </Dropdown>
      </div>
      <div className="copyright-container mt-2 mb-[80px] font-primaryFont text-center">
     <span className="text-sm"> © 2024 SNITCH - Parag Unhale</span>
 <p>Made in India, for the World 🌍</p>
      </div>
    </footer>
  );
}

export default Footer;
